const e=async(e,t,n,r)=>{await e.delete(`/webhooks/${t}/${n}/${r}`)};export{e as deleteWebhook};
//# sourceMappingURL=delete-webhook.mjs.map